import React from "react";
import useServiceListUtils from "./servicelistUtils";
import CommonTable from "../../common/commonTable";
import { CommonFilters, TitleHeader } from "../../components";

const columns = [
  { label: "title", key: "title" },
 
  { label: "Status", key: "status" },
];

const ServiceList = () => {
  const {
    listData,
    loading,
    currentPage,
    limit,
    fetchServiceData,
    handleSearch,
    handleFilter,
    handlePageChange,
  } = useServiceListUtils();

  const formattedData = (listData?.docs || []).map((item) => ({
    ...item,
    ...(item.service_descriptions || {}),
    title: item.service_descriptions?.title || "N/A",
  }));

  return (
    <>
      <TitleHeader heading="Welcome to Jayeek!  " buttonText="+ Add New" />
      <div className="page-card-bg table-data-new">
        <CommonFilters
          heading="Service List"
          handleSearch={handleSearch}
          handleFilter={handleFilter}
         
        />
        <CommonTable
          columns={columns}
          data={formattedData || []}
          loading={loading}
        />
      </div>
    </>
  );
};

export default ServiceList;
